import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
interface FAQItemProps {
  question: string;
  answer: string;
}
export function FAQItem({
  question,
  answer
}: FAQItemProps) {
  const [isOpen, setIsOpen] = useState(false);
  return <div className="border-b border-sage-dark last:border-0" data-id="element-6">
      <button onClick={() => setIsOpen(!isOpen)} className="flex justify-between items-center w-full py-6 text-left focus:outline-none" aria-expanded={isOpen} data-id="element-7">
        <span className="text-lg font-medium text-cream pr-8" data-id="element-8">{question}</span>
        <motion.div animate={{
        rotate: isOpen ? 180 : 0
      }} transition={{
        duration: 0.3,
        ease: 'easeInOut'
      }} className="flex-shrink-0 text-coral" data-id="element-9">
          <ChevronDown className="w-6 h-6" data-id="element-10" />
        </motion.div>
      </button>
      <AnimatePresence initial={false} data-id="element-11">
        {isOpen && <motion.div initial={{
        height: 0,
        opacity: 0
      }} animate={{
        height: 'auto',
        opacity: 1
      }} exit={{
        height: 0,
        opacity: 0
      }} transition={{
        duration: 0.3,
        ease: 'easeInOut'
      }} className="overflow-hidden" data-id="element-12">
            <div className="pb-6 text-cream/80 leading-relaxed" data-id="element-13">{answer}</div>
          </motion.div>}
      </AnimatePresence>
    </div>;
}